function showFooterEmailSignupSuccess() {
  const params = new URLSearchParams(window.location.search);

  if (params.get('customer_posted') !== 'true') return;

  document.querySelectorAll('footer [data-email-signup-block]').forEach((block, index) => {
    const inputGroup = block.querySelector('[data-email-signup-input-group]');
    const successMessage = block.querySelector('[data-email-signup-success-message]');

    if (!inputGroup || !successMessage) return;

    inputGroup.hidden = true;
    successMessage.hidden = false;

    if (index === 0) {
      successMessage.focus({ preventScroll: true });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', showFooterEmailSignupSuccess, { once: true });
} else {
  showFooterEmailSignupSuccess();
}
